module.exports = __webpack_public_path__ + "img/ballantines-first-block-bg-mobile.d8939b3e.jpg";